module.exports = __webpack_public_path__ + "static/uni_welfare_old-7f608046e3e802c1774b0721a71705f9.png";